import * as React from "react";
import { SVGProps } from "react";
export const EnvelopeFillIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M3.41699 16.667C2.93099 16.667 2.51766 16.4967 2.17699 16.156C1.83699 15.816 1.66699 15.403 1.66699 14.917V5.08301C1.66699 4.59701 1.83699 4.18401 2.17699 3.84401C2.51766 3.50334 2.93099 3.33301 3.41699 3.33301H16.583C17.069 3.33301 17.4823 3.50334 17.823 3.84401C18.163 4.18401 18.333 4.59701 18.333 5.08301V14.917C18.333 15.403 18.163 15.816 17.823 16.156C17.4823 16.4967 17.069 16.667 16.583 16.667H3.41699ZM9.99999 10.792C10.0833 10.792 10.1633 10.778 10.24 10.75C10.316 10.722 10.3887 10.6873 10.458 10.646L16.229 7.04201C16.3403 6.97267 16.4273 6.88934 16.49 6.79201C16.552 6.69467 16.583 6.56967 16.583 6.41701C16.583 6.12501 16.4617 5.90967 16.219 5.77101C15.9757 5.63167 15.722 5.63867 15.458 5.79201L9.99999 9.20801L4.54199 5.79201C4.30599 5.63867 4.05933 5.63501 3.80199 5.78101C3.54533 5.92701 3.41699 6.13901 3.41699 6.41701C3.41699 6.56967 3.44799 6.69801 3.50999 6.80201C3.57266 6.90601 3.65966 6.98601 3.77099 7.04201L9.54199 10.646C9.61133 10.6873 9.68399 10.722 9.75999 10.75C9.83666 10.778 9.91666 10.792 9.99999 10.792Z"
            fill="currentColor"
        />
    </svg>
);
EnvelopeFillIcon.displayName = "EnvelopeFillIcon";
